import { useConsole } from "contexts/Console"
import { Provider } from "contexts/Locale"
import { match } from "path-to-regexp"
import { useLocation } from "react-router-dom"

export default function Locale({ children, schema = "/:locale", initialState /*: { default_locale: defaultLocale, locale, locales }*/ }) {
  const console = useConsole()
  const location = useLocation()

  const banners = initialState.banners
  const codes = initialState.locales.map(({ codes: { www } }) => www)
  const externalCodes = (initialState.external_locales ?? []).map(({ codes: { www } }) => www)
  schema = schema.replace(":locale", `:locale(${codes.join("|")})?`)
  const extendedSchema = schema.replace(":locale", `:locale(${[...codes, ...externalCodes].join("|")})?`)
  const urlCode = match(`${schema}/:slug(.*)?`)(location.pathname)?.params?.locale ?? initialState.default_locale.codes.www
  const locale = initialState?.[urlCode]?.locale
  const dir = locale?.dir

  const collator = new Intl.Collator("en", { sensitivity: "base" })

  const sort = (localeA, localeB) => {
    const a = localeA.sortLabel || localeA.label
    const b = localeB.sortLabel || localeB.label
    if (localeA.priority !== localeB.priority) {
      return localeB.priority - localeA.priority
    }
    return collator.compare(a, b)
  }

  const regions = [
    { region: "america", locales: initialState.locales.filter(locale => locale.region === "america" && !locale.hide).sort(sort) },
    {
      region: "asia",
      locales: initialState.locales.filter(locale => locale.region === "asia" && !locale.hide).sort(sort),
    },
    { region: "europe", locales: initialState.locales.filter(locale => locale.region === "europe" && !locale.hide).sort(sort) },
    { region: "africa", locales: initialState.locales.filter(locale => locale.region === "africa" && !locale.hide).sort(sort) },
    { region: "other", locales: initialState.locales.filter(locale => locale.region === "other" && !locale.hide).sort(sort) },
  ]

  const ctx = {
    banners,
    codes,
    externalCodes,
    current: locale,
    defaultLocale: initialState.default_locale,
    dynamic: !locale.codes.country,
    dir,
    locale,
    locales: initialState.locales.filter(locale => !locale.duplicate),
    externals: initialState.external_locales,
    regions,
    schema,
    extendedSchema,
  }
  // Due to digitalDataLayer function being outside of the React component tree,
  // we need to set the locale in the global object for it to be accessible.
  if (process.browser) {
    global.__rlx ??= {}
    global.__rlx.locale = locale.codes.www
    global.__rlx.lang = locale.codes.ws
  }

  console.verbose("Locale:ctx(%o)", ctx)
  return <Provider value={ctx}>{children}</Provider>
}
